<div
  *ngFor="let number of WeekInYearArray"
  class="text-[8px] text-diagram-gray opacity-70 flex justify-center items-center"
  [style.min-width.px]="cellSize"
>
  {{ number }}
</div>
